module.exports = __webpack_public_path__ + "static/media/search.c9b948f0.svg";